import React from 'react';
import {InlineMath} from 'react-katex';
import GraphViewer from '../../components/GraphPlotter/GraphViewer';
import CollapsibleTaskDiagram from '../../components/diagrams/CollapsibleTaskDiagram';

export function circleDiagramData([a,b,c,d,e,f]) {
 const A={x:b,y:d*b+e},B={x:c,y:d*c+e};
 const C={x:b+(c-b)*(1-d*f)/(1+f*f),y:d*b+e+(c-b)*(d+f)/(1+f*f)};
 const center={x:(A.x+B.x)/2,y:(A.y+B.y)/2},radius=Math.hypot(B.x-A.x,B.y-A.y)/2;
 const vertexX=(a*(b+c)-d)/(2*a),vertexY=a*vertexX**2+(d-a*(b+c))*vertexX+e+a*b*c;
 const minX=Math.min(0,center.x-radius,A.x,C.x),maxX=Math.max(center.x+radius,B.x,C.x);
 const minY=Math.min(0,center.y-radius,vertexY),maxY=Math.max(0,center.y+radius,C.y);
 const padding=Math.max(.4,radius*.35),startDeg=Math.atan2(B.y-A.y,B.x-A.x)*180/Math.PI;
 const xRange=[minX-padding,maxX+padding],yRange=[minY-padding,maxY+padding],halfAngle=Math.atan(f)/2;
 const bisector=startDeg*Math.PI/180+halfAngle;
 const unitsPerPixel=Math.max(xRange[1]-xRange[0],yRange[1]-yRange[0])/240;
 const labelRadius=Math.min(1.6*radius,Math.max(.65*radius,9*unitsPerPixel/Math.sin(halfAngle)));
 const labelSize=Math.max(10,Math.min(16,2*labelRadius*Math.sin(halfAngle)/unitsPerPixel-2));
 const alphaLabel={x:A.x+labelRadius*Math.cos(bisector),y:A.y+labelRadius*Math.sin(bisector)};
 return {A,B,C,center,radius,xRange,yRange,alphaLabel,labelRadius,labelSize,startDeg,endDeg:startDeg+Math.atan(f)*180/Math.PI};
}

export default function May2023CircleDiagram({data,lineLatex,parabolaLatex}) {
 const [a,b,c,d,e]=data,g=circleDiagramData(data),orange='#ff9800',purple='#b10dc9',green='#2ecc40';
 const xs=Array.from({length:401},(_,i)=>g.xRange[0]+(g.xRange[1]-g.xRange[0])*i/400);
 return <CollapsibleTaskDiagram>
  <figure style={{margin:0,display:'flex',flexWrap:'wrap',gap:16,alignItems:'center'}}>
   <div style={{flex:'1 1 300px',minWidth:0,maxWidth:520}}>
    <GraphViewer width={520} mathLabels showCoordinates={false} showGrid
     xRange={g.xRange} yRange={g.yRange}
     equations={[{expr:`(${d})*x+(${e})`,color:purple,width:2}]}
     curves={[{x:xs,y:xs.map(x=>a*x*x+(d-a*(b+c))*x+e+a*b*c),color:orange,width:3}]}
     circles={[{center:g.center,radius:g.radius,color:green,width:2}]}
     points={{A:{...g.A,color:green,textPosition:'bottom left'},B:{...g.B,color:green,textPosition:'bottom right'},C:{...g.C,color:green,textPosition:'top left'},alpha:{...g.alphaLabel,label:'α',showDot:false,color:purple,labelSize:g.labelSize,textPosition:'middle center'}}}
     segments={[{p1:'A',p2:'C',color:purple,width:2,showMarkers:false}]}
     arcs={[{center:g.A,radius:g.radius*.35,startDeg:g.startDeg,endDeg:g.endDeg,color:purple,width:2}]}/>
   </div>
   <figcaption style={{flex:'1 1 180px',minWidth:0,fontSize:16}}>
    <p style={{color:orange}}><InlineMath math={parabolaLatex}/></p>
    <p style={{color:purple}}><InlineMath math={`l:\\;${lineLatex}`}/></p>
    <p style={{color:green}}>okrąg <InlineMath math="\mathcal O"/></p>
   </figcaption>
  </figure>
 </CollapsibleTaskDiagram>;
}
